import React, { useContext } from 'react';
import { Routes, Route } from "react-router-dom";
import { ConfigProvider } from 'antd';
// import SystemDashBoard from './system_dash_board';
import AllSchedule from './all_schedule';
import WorkSchedule from './work_schedule';
import HistorySchedule from './history_schedule';
import ChangeSchedule from './change_schedule';
// import SumWorkedTime from './sum_worked_time';
// import AutoGenerate from './auto_generate';
import ShiftOverview from './shift_overview';
import ShiftOverviewCalender from './shift_overview_calender';
import ClassSettingOverView from './class_setting_overview';
import HolidayOverView from './holiday_overview';
import HolidayDetailOverView from './holiday_detail_overview';
import WeekOverview from './week_overview';
import Label_language from "../language";
import { Mainlayout } from '../ui/ot';
import Main from '../utility/Main';
const label_language = Label_language.shift_management
const { ConfigContext } = ConfigProvider;
export default function App() {
    const configContext = useContext(ConfigContext);
    const language = configContext.locale.locale
    return (
        <Routes>
            <Route path={''} element={
                <Mainlayout />
            } >
                <Route path={''} element={
                    <Main
                        language={label_language}
                    />
                } />
                <Route path={'class_setting_overview'} element={
                    <ClassSettingOverView />
                } />
                <Route path="holiday_overview" >
                    <Route path="" element={
                        <HolidayOverView />
                    } />
                    <Route path="detail" element={
                        <HolidayDetailOverView />
                    } />
                </Route>
                <Route path={'week_overview'} element={
                    <WeekOverview />
                } />
                <Route path={'shift_overview'} element={
                    <ShiftOverview />
                } />
                <Route path={'shift_overview_calender'} element={
                    <ShiftOverviewCalender />
                } />
                {/* <Route path="system_dashboard" element={
                    <SystemDashBoard />
                } /> */}
                {/* <Route path="system_workschedule/:employeenumber" element={
                    <Main_layout
                        path={[
                            {
                                path: "",
                                name: "班次設定"
                            }
                        ]}
                        title={"班次設定"}>
                        <WorkSchedule />
                    </Main_layout>
                } /> */}
                <Route path="system_historyschedule" element={
                    <HistorySchedule />
                } />
                <Route path="system_allschedule" element={
                    <AllSchedule />
                } />
                <Route path="system_changeschedule" element={
                    <ChangeSchedule />
                } />
                {/* <Route path="system_workedtime" element={
                    <SumWorkedTime />
                } />
                <Route path="system_autogenerate" element={
                    <AutoGenerate />
                } /> */}
            </Route>
        </Routes>
    );
}